import { useState } from "react";
import { UserX, UserCheck } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function BlockButton({ userId, userName, isBlocked: initialBlocked = false, onToggle }) {
  const { user } = useAuth();
  const [isBlocked, setIsBlocked] = useState(initialBlocked);
  const [busy, setBusy] = useState(false);

  // Don't show block button for own profile or if not logged in
  if (!user || userId === user.user_id) {
    return null;
  }

  const handleToggle = async () => {
    setBusy(true);
    try {
      if (isBlocked) {
        await api.delete(`/users/block/${userId}`);
        toast.success(`Unblocked ${userName}`);
        setIsBlocked(false);
      } else {
        await api.post(`/users/block/${userId}`);
        toast.success(`Blocked ${userName} - you will no longer see their messages`);
        setIsBlocked(true);
      }
      if (onToggle) onToggle(!isBlocked);
    } catch (e) {
      toast.error(apiErr(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={handleToggle}
      disabled={busy}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-xs border rounded transition-colors ${
        isBlocked
          ? "border-emerald-700 bg-emerald-950/20 text-emerald-400 hover:bg-emerald-950/30"
          : "border-red-700 bg-red-950/20 text-red-400 hover:bg-red-950/30"
      } disabled:opacity-50 disabled:cursor-not-allowed`}
      title={isBlocked ? "Unblock this user" : "Block this user (hides their messages)"}
    >
      {isBlocked ? (
        <>
          <UserCheck size={14} /> Unblock
        </>
      ) : (
        <>
          <UserX size={14} /> Block User
        </>
      )}
    </button>
  );
}
